import React from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreator from './../../../../store/actions/index';
import { withStyles, Typography } from "@material-ui/core";
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import t from "../../../../languages/pl";
import useStyles from "./buttonGroupStyle";
import Reports from "./NotificationsAndAlerts/Reports";
import ScheduledActivity from "./NotificationsAndAlerts/ScheduledActivity";
import Inspection from "./NotificationsAndAlerts/Inspection";

const CarNotifications = props => {
    const { classes, carId, registrationNo, insuranceDate, inspections, reports } = props;

    const handleInsuranceOpen = () => {
        props.getInsuranceDates(carId);
    };

    const handleInsuranceSubmit = (newDate) => {
        props.patchInsuranceDate(carId, newDate);
    };

    const handleReportsOpen = () => {
        props.getCarReports(carId);
    };

    const handleReportsSubmit = (data) => {
        props.patchCarReports(carId, data);
    };

    const handleInspectionsOpen = () => {
        props.getInspections(carId);
    };

    const handleInspectionSubmit = (data) => {
        props.patchInspections(carId, data);
    };

    const handleResetServiceRemainders = (data) => {
        props.resetInspections(carId, data);
    };

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <NotificationImportantIcon style={{marginRight: 5}} />
                <Typography variant="body1">{t.alertsAndNotifications}</Typography>
            </div>
            <div className={classes.content}>
                <Inspection
                    name={registrationNo}
                    data={inspections}
                    onDialogOpen={handleInspectionsOpen}
                    onSubmit={handleInspectionSubmit}
                    onResetServiceRemainders={handleResetServiceRemainders}
                />
                <Reports
                    name={registrationNo}
                    data={reports}
                    onDialogOpen={handleReportsOpen}
                    onSubmit={handleReportsSubmit}
                />
                <ScheduledActivity
                    name={registrationNo}
                    title={t.insurance}
                    label={t.nextInsuranceDate}
                    date={insuranceDate.data_ubezpieczenia}
                    onDialogOpen={handleInsuranceOpen}
                    onSubmit={handleInsuranceSubmit}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    insuranceDate: state.carsReducer.insuranceDate,
    inspections: state.carsReducer.inspections,
    reports: state.carsReducer.reports
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


export default compose(
    withStyles(useStyles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(CarNotifications);

CarNotifications.propTypes = {
    classes: PropTypes.object,
    carId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    registrationNo: PropTypes.string,
    //redux
    insuranceDate: PropTypes.object,
    getInsuranceDates: PropTypes.func,
    inspections: PropTypes.object,
    getInspections: PropTypes.func,
    patchInsuranceDate: PropTypes.func,
    patchInspections: PropTypes.func,
    resetInspections: PropTypes.func,
    getCarReports: PropTypes.func,
    reports: PropTypes.object,
    patchCarReports: PropTypes.func
};